import { render, staticRenderFns } from "./MiniproLiveForm.vue?vue&type=template&id=607e3d61&scoped=true&"
import script from "./MiniproLiveForm.vue?vue&type=script&lang=js&"
export * from "./MiniproLiveForm.vue?vue&type=script&lang=js&"
import style0 from "./MiniproLiveForm.vue?vue&type=style&index=0&id=607e3d61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e3d61",
  null
  
)

export default component.exports